import * as c from '../../../../../../constants.jsx';
import NewbornPanelsCardTemplate from '../../../../../../components/CockpitCards/NewbornPanelsCardTemplate.jsx';

export default function EndocrineNewbornCard() {

return(
<>

<NewbornPanelsCardTemplate

  panel_url = {`${c.API_URL}/api/endocrinenewborn`}

  panel_name = { "ENDOCRINE DISORDERS" }
  panel_subtext = {"This panel is based on the Recommended Uniform Screening Panel (RUSP), a list of conditions selected by experts for newborn screening programs."}

/>

</> 
)}

